// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"106":"4d7166c7","295":"c54bbcef","534":"d3903d16","626":"4c68a991","739":"94ade9a8","904":"2ac73fa3"}[chunkId] + ".chunk.js";
};